import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageManager: React.FC = () => {
  const { i18n, t } = useTranslation();

  useEffect(() => {
    const updateLanguageAttributes = () => {
      // Update HTML lang attribute
      document.documentElement.lang = i18n.language;
      
      // Update page title
      document.title = t('meta.title');
    };

    updateLanguageAttributes();
    
    // Listen for language changes
    i18n.on('languageChanged', updateLanguageAttributes);

    return () => {
      i18n.off('languageChanged', updateLanguageAttributes);
    };
  }, [i18n, t]);

  return null; // This component doesn't render anything
};

export default LanguageManager; 